import React, { useState, useEffect, useRef } from 'react';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

import { MainInput, TableList } from './Pages';
const TheMoreContainer = () => {
  const [price, setPrice] = useState('');
  const [list, setList] = useState([]);

  useEffect(() => {
    console.log(list);
  }, [list]);

  const numberInput = useRef();

  const onRemove = (e) => {
    setPrice('');
    setList([]);
  };
  const onChange = (e) => {
    setPrice(e.target.value);
  };
  const onSeach = (e) => {
    e.preventDefault();
    showList();
    numberInput.current.blur();
  };

  const showList = () => {
    const object = [];
    for (let i = 1; i <= 20; i++) {
      const priceList = i * Number(price);
      const saveValue = () => {
        if (priceList - 5000 >= 0) {
          return Number(String(priceList - 5000).substr(-3));
        } else {
          return 0;
        }
      };
      object.push({
        liter: i,
        total: priceList,
        bonus: saveValue(),
        percentage: Math.floor((saveValue() / priceList) * 10000) / 100,
      });
    }
    const sortObject = object.sort((a, b) => {
      return b.percent - a.percent;
    });
    //console.log(sortObject);
    setList(sortObject);
  };
  return (
    <Container
      sx={{
        display: 'flex',
        mt: 2,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box sx={{ width: '100%', maxWidth: 'sm' }}>
        <MainInput
          price={price}
          onSeach={onSeach}
          onChange={onChange}
          onRemove={onRemove}
          numberInput={numberInput}
        />
        <TableList list={list} />
      </Box>
    </Container>
  );
};

export default TheMoreContainer;
